import {Component, OnDestroy, OnInit} from '@angular/core';
import {AssetFilter} from '../../assets/asset-filter';
import {Subscription} from 'rxjs';
import {AssetStateService} from '../../assets/asset.state.service';
import {Badge} from './badge';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {AssetService} from '../../assets/asset.service';
import {UserStateService} from '../../user/user.state.service';
import {User} from '../../user/user';
import {NavStatusService} from '../../nav-status.service';
import {NavigationPoint} from '../../navigation-point';

@Component({
    selector: 'app-active-filters-bar',
    imports: [
        MatIcon,
        MatButton,
        NgClass,
        TranslatePipe
    ],
    templateUrl: './active-filters-bar.component.html',
    styleUrl: './active-filters-bar.component.scss'
})
export class ActiveFiltersBarComponent implements OnInit, OnDestroy {
    assetFilter: AssetFilter | undefined;
    assetFilterSubscription: Subscription | undefined;
    badges: Badge[] = [];
    textSearchBade: Badge | undefined;
    skuSearchBadge: Badge | undefined;
    user: User | null = null;
    userSubscription: Subscription | undefined;
    navSubscription: Subscription | undefined;
    activeNavPoint: NavigationPoint | undefined;

    private readonly badgeBlacklist = [
        'page',
        'resultsPerPage',
        'orderBy',
        'order',
        'collectionUuid',
        'collectionSharedUuid',
        'collectionPublicUuid',
        'q',
        'sku',
    ];

    constructor(
        private assetStateService: AssetStateService,
        private assetService: AssetService,
        private userStateService: UserStateService,
        private navStatusService: NavStatusService
    ) {
    }

    ngOnInit() {
        this.navSubscription = this.navStatusService.getActiveNavPoint().subscribe(res => {
            if (res) {
                this.activeNavPoint = res;
            }
        })
        this.userSubscription = this.userStateService.user$.subscribe(user => {
            this.user = user;
        })
        this.assetFilterSubscription = this.assetStateService.filter$.subscribe(assetFilter => {
            if (assetFilter) {
                this.assetFilter = assetFilter;
                // console.log('assetFilter', assetFilter);
                this.extractBadges(assetFilter);
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 500)
            }
        })
    }

    copyQueryParams() {
        if (this.assetFilter) {
            const QueryString = this.assetService.getParams(this.assetFilter);

            let txt = decodeURIComponent(QueryString.toString());
            txt = '?' + txt.split('[]').join('');
            // console.log(txt);
            navigator.clipboard.writeText(txt).then(() => {
                // console.log('Copied to clipboard');
            })
        }

    }
    getTranslateKey(filterName: string, value: string) :string {
        return 'property.' + filterName.substring(2,filterName.length) + '.' + value;
    }

    extractBadges(assetFilter: AssetFilter) {
        const badges: Badge[] = [];
        for (const key in assetFilter) {
            if (assetFilter.hasOwnProperty(key)) {
                if (!this.badgeBlacklist.includes(key)) {
                    const arr = assetFilter[key] as Array<string>;
                    if (arr && arr.length > 0) {
                        for (let entry of arr) {
                            badges.push({
                                filterName: key,
                                value: entry,
                                translateKey: this.getTranslateKey(key, entry),
                            })
                            //console.log('badges', badges);
                        }
                    }
                }
            }
        }
        if (assetFilter.q && assetFilter.q.length > 0) {
            this.textSearchBade = {
                filterName: 'textSearch',
                value: assetFilter.q,
            }
        } else {
            if (this.textSearchBade) {
                this.textSearchBade = undefined;
            }
        }
        if (assetFilter.sku && assetFilter.sku.length > 0) {
            this.skuSearchBadge = {
                filterName: 'skuSearch',
                value: assetFilter.sku,
            }
        } else {
            if (this.skuSearchBadge) {
                this.skuSearchBadge = undefined
            }
        }
        this.badges = badges;
    }

    removeFilter(badge: Badge) {
        if (this.assetFilter) {
            const key: string = badge.filterName;
            console.log ('key', key);
      if (this.assetFilter[key]) {
        const arr = this.assetFilter[key] as Array<string>;
        let index = arr.indexOf(badge.value);
        if (index !== -1) {
          arr.splice(index, 1);
        }
        if (key === 'p_division') {
          if (this.assetFilter['p_sport']) {
            this.assetFilter['p_sport'] = [];
          }
        }
        if (key === 'p_product_category') {
          if (this.assetFilter['p_product_type']) {
            this.assetFilter['p_product_type'] = [];
          }
                }
                this.assetFilter.page = 1;
                this.assetStateService.filter = this.assetFilter;
            }
        }
    }

    clearAllFilters() {
        this.textSearchBade = undefined;
        this.skuSearchBadge = undefined;
        this.assetStateService.clearFilter();
    }

    clearTextSearchBade() {
        this.textSearchBade = undefined
        if (this.assetFilter) {
            this.assetFilter.q = ''
            this.assetFilter.page = 1;
            this.assetStateService.filter = this.assetFilter;
        }
    }

    clearSkuSearchBade() {
        this.skuSearchBadge = undefined;
        if (this.assetFilter) {
            this.assetFilter.sku = ''
            this.assetFilter.page = 1;
            this.assetStateService.filter = this.assetFilter;
        }
    }

    ngOnDestroy(): void {
        if (this.assetFilterSubscription) {
            this.assetFilterSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    protected readonly NavigationPoint = NavigationPoint;
}
